import React, { useEffect, useRef } from 'react';
import { SettingsIcon } from 'assests/GmsIcons';

type TPageItemProps = {
    index: number;
    value?: string;
    pageLabel?: string;
    pageCount?: number;
    isAutoAdvancement?: boolean;
    pageLayout?: string;
    activeIndex: number | null;
    setActiveIndex: React.Dispatch<React.SetStateAction<number>>;
    setEditPage?: (page: any) => void;
    setPageEditFlag?: (flag: boolean) => void;
};

const   PageItem = ({ index, value, pageLabel, setActiveIndex, activeIndex, pageCount, isAutoAdvancement, pageLayout, setEditPage, setPageEditFlag }: TPageItemProps) => {
    const isActive = index === activeIndex;
    const inputRef = useRef<HTMLInputElement | null>(null);

    const handleInputMouseDown = () => {
        setActiveIndex(index);

        if(setEditPage) {
            setEditPage({
                //key: item?.pageName ?? '',
                value: value,
                pageLabel: pageLabel,
                index: index,
                newPage: false,
            })
        }
        if (setPageEditFlag) {
            setPageEditFlag(false);
        }
    };


    // useEffect(() => {
    //     if (isActive && inputRef.current) {
    //         inputRef.current.focus();
    //     }
    // }, [isActive]);

    return (
        <React.Fragment>
            <div className="tw-h-10 tw-relative tw-flex items-center">
                <input data-testid="components-pageitem-input-1" readOnly={true} ref={inputRef} type="text" placeholder={`Project Title`} value={value} onMouseDown={handleInputMouseDown} className={`tw-flex-grow tw-bg-white !tw-text-[#000] tw-ps-1.5 tw-pe-7  tw-text-sm tw-h-full tw-rounded-tl tw-rounded-tr tw-border ${isActive ? 'tw-border-b-2 tw-border-[#0747A6] tw-bg-[#F0F6FE]' : 'tw-border-zinc-300'} focus:tw-outline-none`} />
                {/* {isActive && pageCount && pageCount > 1 ? <button onClick={handleDeleteClick} className="tw-absolute tw-bottom-3 tw-right-2 tw-ps-[5px] tw-z-10 tw-text-[10px] tw-flex items-center tw-bg-[#747593] tw-h-4 tw-w-4 tw-text-white tw-rounded-[4px] tw-border-none tw-cursor-pointer">X</button> : null}*/}
                {isActive && pageCount ?
                    <button aria-label="Settings" data-testid="components-pageitem-button-2" className="tw-absolute tw-bottom-3 tw-right-2 tw-ps-[5px] tw-z-10 tw-text-[10px] tw-flex items-center tw-h-4 tw-w-4 tw-text-white tw-rounded-[4px] tw-border-none tw-cursor-pointer" 
                        onClick={() => {
                                //handleDeleteClick();
                                if(setEditPage) {
                                    setEditPage({
                                        value: value,
                                        pageLabel: pageLabel,
                                        isAutoAdvancement: isAutoAdvancement,
                                        pageLayout: pageLayout,
                                        index: index,
                                        newPage: false,
                                    })
                                }
                                if(setPageEditFlag) setPageEditFlag(true);
                            }
                        }
                    >
                        <SettingsIcon/>
                    </button> : null}
            </div>
        </React.Fragment>
    );
};

export default PageItem;
